export const REGISTRATION_SECTION_KEYS = Object.freeze({
  PERSONAL_INFO: 'personal_info',
  VEHICLE_INFO: 'vehicle_info',
  DRIVERS_LICENSE: 'drivers_license',
});

export const IDENTITY_VALIDATION_OK = 'OK';

export const INVALID_IDENTITY_NUMBER = 'INVALID_IDENTITY_NUMBER';

export const UPLOAD_INVALID_RESPONSE = 'UPLOAD_INVALID_RESPONSE';
